import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=69828f3c&scoped=true&"
import script from "./gameList.vue?vue&type=script&lang=js&"
export * from "./gameList.vue?vue&type=script&lang=js&"
import style0 from "./gameList.vue?vue&type=style&index=0&id=69828f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69828f3c",
  null
  
)

export default component.exports